<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import AdminForm from '@/components/admin/AdminForm.vue'
import AdminAdminFleetForm from '@/components/admin/adminFleet/AdminAdminFleetForm.vue'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import { SecurityItemsKeys } from '@/enum/SecurityItems'

@Component({
  name: 'AdminAdminFleet', 
  components: {AdminAdminFleetForm},
  props:{
    itemid:{
      type:Number
    }
  }
})
export default class AdminAdminFleet extends AdminForm<AloDbFleet> {  

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_FLEET].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }
  
  get itemTypeName(){
    return "AdminFleet"
  }

  get originalLibelle(){
    return this.original.FLE_LIBELLE
  }
}
</script>